import { Field, FieldProps } from 'formik'
import * as moment from 'moment'
import * as React from 'react'
import { IFormValues } from './PersonalInfoForm'
import { Datepicker, MbscCalendarEvent } from '@mobiscroll/react'

const InnerDatePicker = (props: { name: string; type?: string; label?: string }) => {
  const getPicker = (form: any): any => {
    const handleSelect = (date: MbscCalendarEvent) => {
      form.setFieldValue(props.name, date ? moment(date.value).toString() : undefined)
    }
    return (
      <Datepicker
        controls={['calendar']}
        dateFormat='MM/DD/YYYY'
        max={moment(new Date())}
        min={moment().subtract(100, 'years')}
        value={form.values[props.name] ? moment.utc(form.values[props.name]) : null}
        onChange={handleSelect}
        theme='ios'
        themeVariant='light'
        inputStyle='box'
        labelStyle='floating'
        touchUi={false}
        display='anchored'
        calendarScroll='horizontal'
        label={props.label}
      />
    )
  }

  return <Field name={props.name}>{({ field, form }: FieldProps<IFormValues>) => <div>{getPicker(form)}</div>}</Field>
}

export default InnerDatePicker



// WEBPACK FOOTER //
// ./src/components/riders/editrider/personalinfo/InnerDatePicker.tsx